function createBlock(index, title, isGlowBlock, subtypeOptions) {
    return {
        index: index,
        title: title,
        isGlowBlock: isGlowBlock,
        subtypeOptions: subtypeOptions
    }
}

const focusBlockSubtypes=["work", "meeting", "unspecified"]
const fuelBlockSubtypes=["breakfast", "snack", "lunch", "dinner", "unspecified"]
const fitnessBlockSubtypes=["weights", "cardio", "unspecified"]
const planBlockSubtypes=["weekday relax", "breathwork", "unspecified"]
const transitionBlockSubtypes=["morning routine", "evening routine", "from work", "to work", "focusHelp", "unspecified"]
const relaxBlockSubtypes=["free relax", "breathwork", "stretch", "sleep", "unspecified"]

const focusBlock = createBlock(0, "focus", false, focusBlockSubtypes)
const fuelBlock = createBlock(1, "fuel", true, fuelBlockSubtypes)
const fitnessBlock = createBlock(2, "fitness", true, fitnessBlockSubtypes)
const planBlock = createBlock(3, "plan", false, planBlockSubtypes)
const transitionBlock = createBlock(4, "transition", true, transitionBlockSubtypes)
const relaxBlock = createBlock(5, "relax", true, relaxBlockSubtypes)

const workingBlocks = [
    focusBlock, 
    fuelBlock, 
    fitnessBlock, 
    planBlock, 
    transitionBlock, 
    relaxBlock]
export default workingBlocks;